// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0bb09c05","688":"af53ef29"}[chunkId] + ".chunk.js";
};